import { inject, Injectable } from '@angular/core';
import { FAQ } from './models/faq.model';
import { PageContent } from './models/page-content.model';
import { Observable } from 'rxjs';
import { ApiWrapperService } from 'ngx-apiwrapper';

@Injectable({
  providedIn: 'root'
})
export class SitePagesService {
private readonly _apiWrapper = inject(ApiWrapperService);

  // async getFaq() : Promise<FAQ[]> {
  //   return new Promise(resolve => {
  //       this.httpClient.get<FAQ[]>(`/api/pages/faq`).subscribe(result => resolve(result))
  //   })
  // }

  getTerms() : Observable<PageContent> {
    return this._apiWrapper.get('pages/getterms')
  }

  getPrivacyPolicy() : Observable<PageContent> {
    return this._apiWrapper.get('pages/getprivacypolicy');
  }
}
